export enum UserInteractionTypes {
    Interactive = "interactive",
    Noninteractive = "noninteractive",
}
